export const LOGIN_QUESTIONS = 'login-questions';
export const FORGOT_PASSWORD = 'forgot-password';
export const STANDARD_LOGIN = 'standard-login';
export const SSO_LOGIN = 'sso-login';
export const AMP = 'AMP';
export const ONE = 'ONE';
export const ONEHUB = 'ONEHUB';
export const RMP = 'RMP';
export const HMK = 'HMK';
